export function getListNeighborId(
	orderedIds: string[],
	currentId: string,
	direction: "forward" | "backward",
): string | undefined {
	const idx = orderedIds.indexOf(currentId)
	if (idx < 0) return undefined
	return direction === "forward" ? orderedIds[idx + 1] : orderedIds[idx - 1]
}
